import {Component, OnInit} from '@angular/core';
import {MenuItem} from '../../model/MenuItem';
import {AuthService} from '../../service/auth.service';
import {NavigationEnd, Router} from '@angular/router';
import {UrlHelper} from '../../helper/url.helper';

@Component({
  selector: 'app-settings-dashboard',
  templateUrl: './settings-dashboard.component.html',
  styleUrls: ['./settings-dashboard.component.scss']
})
export class SettingsDashboardComponent implements OnInit {

  links: MenuItem[] = [
    {
      path: 'schools',
      label: $localize`:Navigation|Schools Manage title@@navigation-schools-manage-title:Manage Schools`
    },
  ];

  noSettingsSelected = false;

  constructor(private authService: AuthService,
              private router: Router) {
  }

  ngOnInit() {
    this.noSettingsSelected = this.router.url == UrlHelper.SETTINGS_DASHBOARD_PATH;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.noSettingsSelected = event.url == UrlHelper.SETTINGS_DASHBOARD_PATH;
      }
    });
  }
}
